// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2lFGz","bigColWidth":"Table_bigColWidth__2QNIj","biggerColWidth":"Table_biggerColWidth__CVxNR","row":"Table_row__1wlQt","col":"Table_col__11YrR"};